import { BaseResponse } from './internal/baseresponse';

export class TransactionCheckRemittanceResult extends BaseResponse {
  data: Array<string> = new Array<string>();
}



// WEBPACK FOOTER //
// ./src/app/response/transactioncheckremittanceresult.ts